module.exports = __webpack_public_path__ + "static/media/trump-johnson-trudeau-sentiment.37cc69de.png";